var _path, _path2, _path3, _path4, _g, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscount25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17238 47.332C6.67972 48.1827 7.48887 48.8112 8.43871 49.0922L13.0289 50.4503L18.4326 52.0166C19.4816 52.3207 20.6097 52.1758 21.5478 51.6164L46.7963 36.5596C48.6654 35.445 49.277 33.0263 48.1624 31.1573L40.1086 17.6519C38.994 15.7829 36.5753 15.1713 34.7063 16.2859L9.38886 31.3837C8.49132 31.919 7.84317 32.7888 7.58699 33.802L5.16335 43.3867C4.90716 44.3999 5.06394 45.4733 5.59918 46.3708L6.17238 47.332ZM11.3917 43.5154C10.987 42.8368 10.1089 42.6148 9.43026 43.0194C8.75166 43.4241 8.5296 44.3023 8.93428 44.9809C9.33896 45.6595 10.2171 45.8815 10.8957 45.4769C11.5743 45.0722 11.7964 44.194 11.3917 43.5154Z",
    stroke: "#FC916B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1255 28.7371C32.8984 28.2762 33.1673 27.3028 32.7262 26.563C32.285 25.8232 31.3008 25.5971 30.5279 26.058C29.755 26.5189 29.4861 27.4923 29.9272 28.2321C30.3684 28.9719 31.3526 29.198 32.1255 28.7371Z",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7495 31.8172C40.5224 31.3562 40.7914 30.3829 40.3502 29.6431C39.909 28.9033 38.9248 28.6772 38.1519 29.1381C37.379 29.599 37.1101 30.5724 37.5513 31.3122C37.9924 32.052 38.9766 32.2781 39.7495 31.8172Z",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5939 23.3438L33.4319 34.8003",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3190_7134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11328 21.3672C2.11328 21.3672 6.98867 23.1319 8.11566 23.9235",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69141 4.62695C8.78967 6.68333 10.0565 8.64512 11.479 10.4922C12.5015 11.791 15.7674 16.973 15.7674 16.973",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2866 5.16211C26.2866 5.16211 25.3652 10.8106 25.4106 11.0097",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1976 38.4309L16.2464 38.5253L16.3377 38.4709L17.5322 37.7585L17.6154 37.7089L17.5684 37.6241C17.4066 37.3325 17.4115 37.0086 17.5765 36.6817C17.7431 36.3515 18.0739 36.0186 18.5613 35.7279C19.0336 35.4462 19.4565 35.3297 19.8036 35.3598C20.1456 35.3895 20.4241 35.5621 20.616 35.884C20.7862 36.1693 20.7867 36.4961 20.6289 36.8252C20.4698 37.1569 20.1495 37.4897 19.6833 37.7677C18.7817 38.3054 18.1724 38.9313 17.8927 39.6023C17.6111 40.2779 17.6684 40.9881 18.0782 41.6752L19.1229 43.4272L19.1742 43.513L19.2601 43.4618L24.8544 40.1256L24.9402 40.0744L24.889 39.9885L24.242 38.9035L24.1907 38.8176L24.1049 38.8688L19.7511 41.4652L19.4046 40.8842C19.228 40.5881 19.227 40.2701 19.3933 39.9473C19.5621 39.6195 19.9051 39.2852 20.419 38.9788C21.3295 38.4357 21.9322 37.8244 22.1964 37.1592C22.4628 36.4888 22.3791 35.7798 21.9506 35.0612C21.5439 34.3793 20.9414 33.9822 20.2219 33.8887C19.5057 33.7957 18.6846 34.0046 17.8355 34.5109C16.9676 35.0285 16.3733 35.6496 16.0884 36.3244C15.8022 37.0024 15.8327 37.7252 16.1976 38.4309ZM26.0339 33.1709L24.6465 33.9982L23.8941 32.7366L27.6406 30.5023L27.7265 30.4511L27.6753 30.3652L27.0223 29.2702L26.9711 29.1843L26.8852 29.2356L21.8981 32.2096L21.8122 32.2609L21.8634 32.3468L24.0124 35.9502L24.0636 36.0361L24.1495 35.9849L26.7774 34.4177C27.2593 34.1303 27.6922 34.0143 28.0491 34.0498C28.4012 34.0848 28.6903 34.268 28.8917 34.6057C29.096 34.9482 29.1212 35.3032 28.9852 35.6415C28.8477 35.9834 28.5415 36.3175 28.066 36.6011C27.5517 36.9078 27.104 37.0481 26.7439 37.0367C26.3905 37.0256 26.1154 36.8686 25.9314 36.5601L25.8802 36.4742L25.7943 36.5254L24.6197 37.2259L24.5338 37.2771L24.585 37.363C25.0061 38.0691 25.6117 38.4724 26.3474 38.5553C27.0783 38.6378 27.9245 38.4027 28.8314 37.8619C29.668 37.3629 30.2365 36.7077 30.49 35.9959C30.7442 35.2822 30.6787 34.519 30.2599 33.8168C29.8252 33.0877 29.2116 32.6563 28.4778 32.5461C27.7475 32.4363 26.9125 32.6469 26.0339 33.1709Z",
    fill: "#FC916B",
    stroke: "#FC916B",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3190_7134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7919,
    height: 23.5911,
    fill: "white",
    transform: "translate(6.21729) rotate(12.6053)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount25);
export default __webpack_public_path__ + "static/media/discount-25.846163511f969401e331452dada36c4a.svg";
export { ForwardRef as ReactComponent };